import f from "classnames";
import a, { forwardRef as A, useMemo as E } from "react";
import { useSizeAttrs as v } from "../utils/hooks/useSizeAttrs.esm.js";
const y = "_button_11651_1 _tappableArea_1kc19_1", g = "_button__icon_11651_558", e = {
  button: y,
  button__icon: g
}, w = A(
  ({
    className: o,
    icon: t,
    children: n,
    size: p = "large",
    variant: s = "primary",
    iconRight: u,
    as: N = "button",
    href: _,
    disabled: r,
    dataTestId: c,
    fullWidth: m,
    ...b
  }, i) => {
    const l = v(p || "large", {}), d = E(
      () => ({
        "data-variant": s,
        "data-full-width": m ? "" : void 0,
        "data-has-icon": t ? "" : void 0,
        "data-icon-right": u ? "" : void 0
      }),
      [m, t, u, s]
    );
    return _ && !r ? /* @__PURE__ */ a.createElement(
      "a",
      {
        ref: i,
        className: f(e.button, "fuse-button", o),
        "data-testid": c,
        href: _,
        ...b,
        ...l,
        ...d
      },
      t && /* @__PURE__ */ a.createElement("span", { className: `${e.button__icon} fuse-button__icon` }, t),
      n
    ) : /* @__PURE__ */ a.createElement(
      N,
      {
        className: f(e.button, "fuse-button", o),
        "data-testid": c,
        ref: i,
        disabled: r,
        ...b,
        ...l,
        ...d
      },
      t && /* @__PURE__ */ a.createElement("span", { className: `${e.button__icon} fuse-button__icon` }, t),
      n
    );
  }
);
w.displayName = "Button";
export {
  w as Button
};
